module.exports = __webpack_public_path__ + "static/img/shi@2x.a7b78657.png";